import { apiFetchPayment } from '../api/client';
import { CHEMISTRY_PAYMENT_PRODUCTS_GLOBAL } from './catalog';

const PAYPAL_SCRIPT_ID = 'paypal-js-sdk';

export const PAYPAL_PRODUCTS = CHEMISTRY_PAYMENT_PRODUCTS_GLOBAL;

export function createPaypalOrder(productId, resultId) {
    return apiFetchPayment('/paypal/orders', {
        method: 'POST',
        body: JSON.stringify({ product_id: productId, result_id: resultId || undefined }),
    });
}

export function capturePaypalOrder(orderId, productId) {
    return apiFetchPayment('/paypal/orders/capture', {
        method: 'POST',
        body: JSON.stringify({ order_id: orderId, product_id: productId }),
    });
}

export function loadPaypalSdk() {
    const clientId = import.meta.env.VITE_PAYPAL_CLIENT_ID;
    if (!clientId) {
        return Promise.reject(new Error('PayPal client id is not configured.'));
    }

    if (window.paypal) {
        return Promise.resolve(window.paypal);
    }

    return new Promise((resolve, reject) => {
        const existing = document.getElementById(PAYPAL_SCRIPT_ID);
        if (existing) {
            existing.addEventListener('load', () => resolve(window.paypal), { once: true });
            existing.addEventListener('error', () => reject(new Error('Failed to load PayPal Checkout.')), { once: true });
            return;
        }

        const script = document.createElement('script');
        script.id = PAYPAL_SCRIPT_ID;
        script.src = `https://www.paypal.com/sdk/js?client-id=${encodeURIComponent(clientId)}&currency=USD&intent=capture`;
        script.async = true;
        script.onload = () => resolve(window.paypal);
        script.onerror = () => reject(new Error('Failed to load PayPal Checkout.'));
        document.body.appendChild(script);
    });
}
